import locator from 'utils/locator';

const isCheckoutUrl = path => path.startsWith('/ecom/checkout');

const isInitialCheckout = !__SERVER__ && isCheckoutUrl(locator.pathname);

export const forceReloadOnCheckoutFactory = ({ location: { pathname } }) =>
  !__SERVER__ && isInitialCheckout !== isCheckoutUrl(pathname) ? () => locator.reload() : null;
